import React, { useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import * as pageRoutes from "../../pageRoutes";
import { apiCall, isThisFeatureAllowed } from "../common/common";
import { useNavigate } from "react-router-dom";
import { MicrosoftLoginButton  } from "react-social-login-buttons";
import {
  loginApi,
  passResetApi,
  confirmPassResetApi,
  tenantInfoApi,
  passThroughApi,
  SUGGESTIONS,
  MATCH_COVERAGE,
} from "../common/constants";
import config from "../../config/config.js";
import {
  setLocalStorageValue,
  removeValueFromLocalStorage,
  getLocalStorageValue,
  setCompanyDateFromLocalStorage,
  clearAllLocalStorageValue
} from "../../utils/localStorageOperations";
import { checkSessionStatus, getTenantInfo } from "../../utils/loginSessionOperations";

import "./login.scss";
import LoginFooter from "./LoginFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Loader from "../common/Loader/Loader";
import { encryptPassword } from "../../utils/passwordEncryption"
import { IconDeviceDesktopSearch, IconRefreshDot, IconDeviceMobileCheck, IconClipboardText } from '@tabler/icons-react';

const errorMsgs = {
  email: "Email is incorrect",
  password: "Pasword is incorrect",
  both: "Email or Password is incorrect",
  fortgotBoth: "Code or Password is incorrect",
  valid: ["Email is required", "Password is required"],
  validEmail: ["Valid Email is required"],
};

const Login = (props) => {
  const navigate = useNavigate();
  const [loginForm, setLoginForm] = useState(true);
  const [resetPassForm, setResetPassForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [passwordType, setPasswordType] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loginStatus, setLoginStatus] = useState(false);
  const [state, setState] = useState({
    email: "",
    password: "",
    code: "",
  });

  function checkPassword(password) {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.[\]{}()?\-"!@#%&/\\><':;|_~`+=-])[A-Za-z\d\^$*.[\]{}()?\-"!@#%&/\\><':;|_~`+=-]{8,}$/;
    
    // Test the password against the regular expression
    return regex.test(password);
  }

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const forgotPassword = () => {
    setErrorMsg("");
    setSuccessMsg("");
    if (state.email.length) {
      setLoading(true);
      const payload = {
        emailAddress: state.email,
      };
      apiCall("POST", passResetApi, "", payload)
        .then(function (response) {
          if (response.status === 200) {
            setLoginForm(false);
            setResetPassForm(true);
          } else {
            alert("Some error ocurred");
          }
          setLoading(false);
        })
        .catch((error) => {
          const errorResponse = error?.response?.data;

          if (
            errorResponse?.message &&
            "errorMessage" in errorResponse.message
          ) {
            let errors = [];
            errors.push(errorResponse.message.errorMessage);
            setErrorMsg(errors);
          } else if (errorResponse && typeof errorResponse === "object") {
            setErrorMsg("An error occurred!");
          } else {
            setErrorMsg(errorResponse);
          }
          setLoading(false);
        });
    } else {
      setErrorMsg(errorMsgs.email);
    }
  };
  const resetPassword = () => {
    setErrorMsg("");
    setSuccessMsg("");

    if(!checkPassword(state.password)){
      setErrorMsg("Password should contain Uppercase , Lowercase , Number , Special (@, $, !, %, *, ?, or &) and Minimun 8 characters.");
      return;
    }
    
    if (state.email.length && state.code.length && state.password.length) {
      setLoading(true);
      const payload = {
        emailAddress: state.email,
        password: state.password,
        confirmationCode: state.code,
      };
      apiCall("POST", confirmPassResetApi, "", payload)
        .then(function (response) {
          if (response.status === 200) {
            setSuccessMsg("Password reset Sucessfully! You can login with new Pasword. Redirecting to Sign in page...");
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          } else {
            alert("Some error ocurred");
          }
          setLoading(false);
        })
        .catch((error) => {
          const errorResponse = error?.response?.data;
          if (
            errorResponse?.message &&
            "errorMessage" in errorResponse.message
          ) {
            let errors = [];
            errors.push(errorResponse.message.errorMessage);
            setErrorMsg(errors);
          } else {
            setErrorMsg(errorResponse);
          }
          setLoading(false);
        });
    } else {
      setErrorMsg(errorMsgs.fortgotBoth);
    }
  };
  const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    var validEmail = re.test(email);
    if (validEmail) {
      let atSplit = email.split("@");
      if (atSplit.length >= 3) {
        return false;
      }
      atSplit = atSplit.pop();
      atSplit = atSplit.split(".");
      if (atSplit.length >= 4) {
        return false;
      }
    }
    return validEmail;
  };
  const sendDetailsToServer = async () => {
    setErrorMsg("");
    setSuccessMsg("");
    setLoading(true);
    localStorage.clear()
    if (
      state.email.length &&
      state.password.length &&
      validateEmail(state.email)
    ) {
      const encryptedPassword = await encryptPassword(state.password.trim());
      const payload = {
        emailAddress: state.email.trim(),
        password: encryptedPassword,
      };
      apiCall("POST", loginApi, "", payload)
        .then(function (response) {
          if (response.status === 200) {
            if (!response.data.data.access_token) {
              alert(response.data.message);
              return false;
            }
            setState((prevState) => ({
              ...prevState,
              successMessage:
                "Registration successful. Redirecting to home page..",
            }));
            // redirectToHome
            // let idTokenParse = parseJwt(response.data.data.id_token);
            setLocalStorageValue("tenant", response.data.data.tenant_code);
            setLocalStorageValue("access_token", response.data.data.access_token);
            setLocalStorageValue("id_token", response.data.data.id_token);
            setLocalStorageValue("passThrough", false);
            setLocalStorageValue("sso_signin",false)
            setLocalStorageValue(
              "refresh_token",
              response.data.data.refresh_token
            );
            setLocalStorageValue("email", state.email);
            setLocalStorageValue("loginEvent", 1);
            setLocalStorageValue("notificationCount", JSON.stringify({count:0, date: (new Date()).toISOString()}))
            setLocalStorageValue("tenant_segments", JSON.stringify(response.data.data.tenant_segments));
            getTenantInfo().then((tenantSet) => {
                setLoading(false);
                if (tenantSet) {
                    let currentUrl = window.location.href;
                    let passThrough = JSON.parse(localStorage.getItem("passThrough"));
                    if (currentUrl.includes('localhost') || !passThrough) {
                        window.location.reload();
                    } else {
                        window.location.href = config.retailscapeUrl;
                    }  
                } else {
                    localStorage.clear();
                    setErrorMsg("Something went wrong. Please contact your Cleardemand administrator.");
                }
            });
          } else {
            alert("Some error ocurred");
          }
        })
        .catch((error) => {
            try {
                const errorResponse = error?.response?.data;
                if (errorResponse?.message?.errorMessage === "User pending email confirmation") {
                    window.location.href = `/register?proc=verify&e=${encodeURIComponent(payload.emailAddress)}&p=${encodeURIComponent(encryptedPassword)}`;
                    return;
                }
                console.error("Error occurred:", error?.message || error);
                if (errorResponse?.message && "errorMessage" in errorResponse.message) {
                    const errors = [errorResponse.message.errorMessage];
                    setErrorMsg(errors);
                } else {
                    setErrorMsg(errorResponse || ["An unknown error occurred."]);
                }
            } catch (catchError) {
                console.error("Error while processing the catch block:", catchError);
                setErrorMsg(["An unexpected error occurred."]);
            } finally {
                setLoading(false);
            }
        });
    } else {
      if (
        state.email.length &&
        state.password.length &&
        !validateEmail(state.email)
      ) {
        setErrorMsg(errorMsgs.validEmail);
      } else {
        setErrorMsg(errorMsgs.valid);
      }
      setLoading(false);
      console.log("Please enter valid username and password");
    }
  };

  const sendPassThroughDetailsToServer = () => {
    setErrorMsg("");
    setSuccessMsg("");
    setLoading(true);
    let windowUrl = window.location.search;
    windowUrl = windowUrl.replace("#","&");
    const params = new URLSearchParams(windowUrl); // get query parameters from hash
    const idToken = params.get("id_token");
    const accessToken = params.get("access_token");
    const tenant = params.get("tenant");
    const locations = params.get("locations");
    const current_location = params.get("current_location");
    const sso_signin = params.get("sso_signin");
    const refresh_token = params.get("refresh_token");
    const passThroughEmail = params.get("email");
    let decodedObj = decodeToken(idToken)
    let email = decodedObj["email"];
    setLocalStorageValue("tenant",tenant);
    // if(idToken && accessToken) {
        let payload = {
            idToken: idToken,
            accessToken: accessToken,
            tenant: tenant
        };      

      apiCall("POST", passThroughApi, "", payload)
        .then(function (response) {
          let segments = [];
          if (response.status === 200) {
            if (!response.data.data.user_email) {
              alert(response.data.message);
              return false;
            }
            setState((prevState) => ({
              ...prevState,
              successMessage:
                "Registration successful. Redirecting to home page..",
            }));
            // redirectToHome
            setLocalStorageValue("tenant",tenant);
            setLocalStorageValue("access_token", accessToken);
            setLocalStorageValue("id_token", idToken);
            setLocalStorageValue("refresh_token",refresh_token);
            setLocalStorageValue("locations", locations);
            setLocalStorageValue("passThroughEmail", passThroughEmail);
            setLocalStorageValue("email", email);
            setLocalStorageValue("passThrough", true);
            setLocalStorageValue("current_location",current_location)
            setLocalStorageValue("sso_signin",sso_signin)
            setLocalStorageValue("tenant_segments",  JSON.stringify(response?.data?.data?.tenant_segments));
            if(passThroughEmail){
              window.gtag("set", "user_properties", {
                user_email_dimension: passThroughEmail,
                user_tenant_dimension : tenant
              });
              window.gtag("event", "login_success");
            }
            setLocalStorageValue("loginEvent", 1);
            getTenantInfo().then((tenantSet) => {
                setLoading(false);
                if (tenantSet) {
                    let currentUrl = window.location.href;
                    let passThrough = JSON.parse(localStorage.getItem("passThrough"));
                    if (currentUrl.includes('localhost') || !passThrough) {
                        window.location.reload();
                    } else {
                        window.location.href = config.retailscapeUrl;
                    }  
                } else {
                    localStorage.clear();
                    setErrorMsg("Something went wrong. Please contact your Cleardemand administrator.");
                }
            });
          } else {
            alert("Some error ocurred");
          }
        })
        .catch((error) => {
          const errorResponse = error?.response?.data;
          console.log(error);
          if (
            errorResponse?.message &&
            "errorMessage" in errorResponse.message
          ) {
            let errors = [];
            errors.push(errorResponse.message.errorMessage);
            setErrorMsg(errors);
          } else {
            setErrorMsg(errorResponse);
          }          
          setLoading(false);
        });
  // }
};

  const enterHandlerForPassword = (e) => {
    if (e.key === "Enter") {
      sendDetailsToServer();
    }
  };

  useEffect(() => {
    if(props.loginType) {
      return
    }
    if(props.ssoRedirect) {
      return
    }

    const idToken = getLocalStorageValue("id_token");
    if (!idToken) {
      document.title = "Cleardemand - Retailscape - Assortment, Competitor Intelligence";
      return
    }
    const decodedObj = decodeToken(idToken);
    // time provided by Auth is in epoch (second)
    // while js uses milliseconds, hence * 1000
    const expirationTime = decodedObj?.exp * 1000;
    const currentTime = Date.now();
    if (expirationTime >= currentTime) {
      navigate(pageRoutes.homePage);
      /*checkSessionStatus(idToken).then((value) => {
        if (value) {
          let modulesAccess = localStorage.getItem("modules")?.split(",") || [];
          if (modulesAccess.includes("Assortment")) {
            if(isThisFeatureAllowed(SUGGESTIONS)){
              navigate(pageRoutes.dashboardPricingPage);
            } else {
              navigate(pageRoutes.dashboardPage);
            }
          } else {
            console.log('modulesAccess', modulesAccess);
            if (modulesAccess.length == 1 && modulesAccess.includes("Reports") && isThisFeatureAllowed(MATCH_COVERAGE)) {
              navigate(pageRoutes.matchCoveragePage);
            } else {
              navigate(pageRoutes.dashboardPricingPage);
            }
          }
        }
      });*/
    } else {
      document.title = "Cleardemand - Retailscape - Login";
    }
    navigate(pageRoutes.homePage);
  }, [navigate]);

  useEffect(()=>{
    if(props.loginType) {
      return
    }
    const paramString = window.location.hash.startsWith('#')
      ? window.location.hash.substring(1)
      : window.location.hash;
    const params = new URLSearchParams(paramString);

    let idToken = params.get("id_token");
    let accessToken = params.get("access_token");
    let refreshToken = params.get("refresh_token");
    if(!refreshToken)
        refreshToken = null;
    let sso_signin = "true"

    if (idToken && accessToken) {
      localStorage.removeItem("id_token");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("sso_signin");
      localStorage.setItem("sso_signin", false);
      localStorage.setItem("id_token", idToken);
      localStorage.setItem("access_token", accessToken);
    }
    const tenant = "meijer"; // hardcoded
    const current_location = "US"; // hardcoded
    const locations = "US"; // hardcoded

    let email = "";
    if (idToken) {
      const parts = idToken.split(".");
      if (parts.length >= 2) {
        try {
          const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
          const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, "=");
          const decodedPayload = JSON.parse(atob(padded));
          if (decodedPayload && decodedPayload.email) {
            email = decodedPayload.email;
          }
        } catch (e) {
          // ignore error
        }
      }
    }

    if (idToken && accessToken) {
      let redirectUrl = `/passThrough?id_token=${encodeURIComponent(idToken)}&access_token=${encodeURIComponent(accessToken)}&refresh_token=${encodeURIComponent(refreshToken || "")}&tenant=${tenant}&sso_signin=${sso_signin}&login_pass=true&current_location=${current_location}&locations=${locations}&login_pass=true`;
      if (email) {
        redirectUrl += `&email=${encodeURIComponent(email)}`;
      }
      window.location.href = redirectUrl;
    }
  
  },[props.ssoRedirect])

  useEffect(()=>{
    let windowUrl = window.location.search;
    windowUrl = windowUrl.replace("#","&");
    let params = new URLSearchParams(windowUrl);
    let loginPass = params.get("login_pass");
    if(props.loginType && loginPass){
      params.delete("login_pass");
      const newSearch = params.toString();
      const newUrl = `${window.location.pathname}?${newSearch}`;
      window.history.replaceState(null, '', newUrl);
      localStorage.clear(); //logout current session if exists
      sendPassThroughDetailsToServer()
    }
  },[props.loginType])


  return (<>{props.loginType ? <Loader loading={true} doNotOverFlow={true} /> : <div className="auth-wrapper">
  <div className="container-fluid">
    <div className="row align-items-center justify-content-center loginPage">
      <div className="col-6 d-none d-lg-block ps-0">
        <div className="h-100">
          <div className="bg-cover-container">
            <div className="bg-cover">
              <div className="bg-cover-level">
                  <div className="row h-100">
                    <div className="col-1"></div>
                    <div className="col-10 m-auto pb-5">
                      <div className="pb-4" style={{fontSize: "3rem"}}>
                          {/*<span className="fw-light">CLEAR </span><span  className="fw-bold">DEMAND</span>*/}
                          <div className="login-logo"></div>
                      </div>
                      <div className="mt-5 fs-1 fw-bold">Welcome to</div>
                      <div className="fw-bold" style={{fontSize: "4rem"}}>Retailscape</div>
                      <div className="fs-1 fw-bold">& Product Matching Tool</div>
                      <div className="w-50 fs-5 mt-3 mb-4">Transform complex data into profitable pricing with industry-leading assortment, price and promotion optimization software.</div>
                      <div className="fs-5 mb-2"><IconDeviceDesktopSearch stroke={2} /> &nbsp; Analyse</div>
                      <div className="fs-5 mb-2"><IconRefreshDot stroke={2} /> &nbsp; Optimize</div>
                      <div className="fs-5 mb-2"><IconDeviceMobileCheck stroke={2} /> &nbsp; Execute</div>
                      <div className="fs-5 mb-5"><IconClipboardText stroke={2} /> &nbsp; Measure</div>
                    </div>
                    <div className="col-1"></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-6 position-relative" style={{height: '100vh'}}>
        <div className="row h-100">
          <div className="col-2"></div>
          <div className="col-8 m-auto">

            <div className="row pad pb-5 mb-5">
              <div className="col-md-12 text-start">
                <ul id="signinErrorList">
                  {Array.isArray(errorMsg)
                    ? errorMsg.map((ele) => (
                        <li className="alert alert-danger">{ele}</li>
                      ))
                    : errorMsg && (
                        <li className="alert alert-danger">{errorMsg}</li>
                      )}
                  {Array.isArray(successMsg)
                    ? successMsg.map((ele) => (
                        <li className="alert alert-success">{ele}</li>
                      ))
                    : successMsg && (
                        <li className="alert alert-success">{successMsg}</li>
                      )}
                </ul>
                <h1 className="text-left mb-3 me-4 fw-bolder">Login</h1>
                <h5 className="text-left mb-5">
                  Please fill in your credentials to continue
                </h5>
                <form>
                  <div>
                    <div className="input-group-lg mb-4">
                      <input
                        id="email"
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Enter Your Email Address"
                        readOnly={resetPassForm}
                        onChange={handleChange}
                      />
                    </div>

                    {resetPassForm && (
                      <div className="input-group-lg mb-4">
                        <input
                          id="code"
                          type="text"
                          name="code"
                          className="form-control"
                          placeholder="Code"
                          onChange={handleChange}
                        />
                      </div>
                    )}

                    {loginForm && (
                      <p className="text-end mt-1 mb-1 recover-password">
                        <a
                          onClick={forgotPassword}
                          className="form-text small cursor-pointer"
                          style={{ textDecoration: "none" }}
                        >
                          Forgot Password?
                        </a>
                      </p>
                      )}
                    <div className="input-group input-group-lg">
                      <input
                        id="password"
                        type={passwordType ? "password" : "text"}
                        className="form-control form-control-appended"
                        placeholder="Enter Your Password"
                        onChange={handleChange}
                        onKeyPress={enterHandlerForPassword}
                      />
                      <span className="input-group-text"><FontAwesomeIcon onClick={e => setPasswordType(!passwordType)} className="cursor-pointer" icon={(passwordType) ? faEye : faEyeSlash} /></span>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        {<p className="forgot-password text-start pt-1 mt-4">
                          Don't have an account yet?{" "}<br/>
                          <Link
                            to="/register"
                            className="text-decoration-none"
                          >
                            Register here
                          </Link>
                        </p>}
                      </div>
                      <div className="col-6">
                        <div className="d-grid gap-2 mt-4">
                          {loading ? <Skeleton width="100%" height="50px" /> : ""}
                          {loginForm && !loading && (
                            <>
                              <button
                              type="button"
                              className="btn btn-lg btn-block btn-dark mb-4 mt-1"
                              onClick={sendDetailsToServer}
                            >
                              Login
                              </button>
                              {/* <MicrosoftLoginButton align="center" className="SSOLogin" style={{height: "40px"}}>
                                <span>Login with Microsoft Azure</span>
                              </MicrosoftLoginButton> */}
                            </>
                          )}
                          {resetPassForm && !loading && (
                            <button
                              type="button"
                              className="btn btn-lg btn-block btn-dark mb-4 mt-1"
                              onClick={resetPassword}
                            >
                              Reset Password
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                </form>
              </div>
              <div className="col-md-12 mt-5">
                <img
                  className="float-start me-2"
                  src="data:image/png;base64,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"
                />
                <div className="mt-2">
                  <small>
                    To ensure you have the best possible experience using
                    Retailscape, we recommend to use Chrome version
                    91 or above
                  </small>
                </div>
              </div>
            </div>

          </div>
          <div className="col-2"></div>
        </div>
        <p className="login-footer pad mb-1">
            <div className="row">
              <div className="col-2"></div>
              <div className="col-8"><LoginFooter showPrivacyPolicy={showPrivacyPolicy} setShowPrivacyPolicy={setShowPrivacyPolicy} /></div>
              <div className="col-2"></div>
            </div>
          </p>
      </div>
    </div>
  </div>
</div>}</>);
};

export default Login;